import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setProgress, setToast } from "../../../redux/slice/system";
import { useAbortedEffect, useHookForm } from "../../../components/hooks";
import { MemberAPI } from "../../../axios/api";

import ModuleBreadCrumb from "../../../components/breadCrumb";
import ModuleTitle from "../../../components/common/title";
import {
  FormInputnumber,
  FormInputtext,
  FormRadio,
  FormCalendar,
} from "../../../components/formElement";
import { formatResData } from "../../../service/common";
import { option_category_obj } from "../../../service/option";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function MemberSettingProfile() {
  const dispatch = useDispatch();
  const redux_user = useSelector((state) => state.user);
  const crumbItem = [
    { key: 1, label: "首頁", href: "/member" },
    { key: 2, label: "系統相關", href: "/member/setting" },
    { key: 3, label: option_category_obj.setting.profile.label },
  ];
  const [reload, setReload] = useState({ detail: true });
  const [apiData, setApiData] = useState({});
  // 表單欄位預設值
  const defaultValues = {
    username: "",
    name: "",
    sex: null,
    birthday: null,
    age: null,
    height: null,
    is_job: null,
    cel: "",
    is_fhofpchd: null,
  };
  const {
    handleSubmit,
    getValues,
    reset,
    trigger,
    yup,
    setSchema,
    errors,
    setting,
  } = useHookForm({
    defaultValues,
  });
  const disabled = true;

  useEffect(() => {
    setSchema(yup.object({}).required());
  }, []);

  useAbortedEffect(
    (signal) => {
      if (!reload.detail) return;

      dispatch(setProgress(true));

      let params = {
        id: redux_user.userDetail.id,
      };

      MemberAPI.getUserListDeatils({
        data: params,
        options: { signal },
      }).then((result) => {
        let { Response, data, message } = result;

        if (Response === 1) {
          let temp = formatResData(defaultValues, data);
          reset(temp);
          setApiData(data);
          setReload((state) => ({
            ...state,
            detail: false,
          }));
        } else {
          dispatch(
            setToast({
              severity: "error",
              summary: message,
              detail: "",
            })
          );
        }

        dispatch(setProgress(false));
      });
    },
    [reload]
  );

  const onSubmit = (submitData) => {
    console.log(submitData);
    return;

    dispatch(setProgress(true));

    let promise,
      jsonData = {
        ...submitData,
      };

    if (apiData.id) {
      jsonData.id = apiData.id;
      promise = MemberAPI.updateAccountData({ data: jsonData });
    } else {
      promise = MemberAPI.setAccountData({ data: jsonData });
    }

    promise.then((result) => {
      let { Response, message } = result;

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary: `變更成功`,
            detail: "",
          })
        );
        setReload((state) => ({ ...state, detail: true }));
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `變更失敗`,
            detail: message,
          })
        );
        dispatch(setProgress(false));
      }
    });
  };

  return (
    <>
      <ModuleBreadCrumb crumbItem={crumbItem} />

      <ModuleTitle
        data={{ title: option_category_obj.setting.profile.label }}
      />

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 py-0 mb-0">
          <label
            htmlFor="username"
            className={classNames(
              { "p-error": errors.username },
              "col-12 sm:col-3 text-left sm:text-right -mb-1 sm:mb-0"
            )}
          >
            帳號
          </label>
          <div className="col-12 sm:col-6 pt-0">
            <FormInputtext
              setting={setting}
              data={{
                name: "username",
                disabled,
              }}
            />
          </div>
        </div>
        <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 py-0 mb-0">
          <label
            htmlFor="name"
            className={classNames(
              { "p-error": errors.name },
              "col-12 sm:col-3 text-left sm:text-right -mb-1 sm:mb-0"
            )}
          >
            姓名
          </label>
          <div className="col-12 sm:col-6 pt-0">
            <FormInputtext
              setting={setting}
              data={{
                name: "name",
                disabled,
              }}
            />
          </div>
        </div>
        <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 py-0 mb-0">
          <label
            htmlFor="sex"
            className={classNames(
              { "p-error": errors.sex },
              "col-12 sm:col-3 text-left sm:text-right -mb-1 sm:mb-0"
            )}
          >
            性別
          </label>
          <div className="flex flex-wrap col-12 sm:col-6 pl-1 pt-0">
            <FormRadio
              setting={setting}
              data={{
                name: "sex",
                label: "男",
                value: 1,
                disabled,
              }}
            />
            <FormRadio
              setting={setting}
              data={{
                name: "sex",
                label: "女",
                value: 2,
                disabled,
              }}
            />
          </div>
        </div>

        <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 py-0 mb-0">
          <label
            htmlFor="birthday"
            className={classNames(
              { "p-error": errors.birthday },
              "col-12 sm:col-3 text-left sm:text-right -mb-1 sm:mb-0"
            )}
          >
            生日
          </label>
          <div className="flex col-12 sm:col-6 pt-0">
            <FormCalendar
              className="w-full -mr-1px"
              setting={setting}
              data={{
                name: "birthday",
                disabled,
              }}
            />
          </div>
        </div>
        <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 py-0 mb-0">
          <label
            htmlFor="age"
            className={classNames(
              { "p-error": errors.age },
              "col-12 sm:col-3 text-left sm:text-right -mb-1 sm:mb-0"
            )}
          >
            年齡
          </label>
          <div className="flex col-12 sm:col-6 pt-0">
            <FormInputnumber
              className="w-full -mr-1px"
              setting={setting}
              data={{
                name: "age",
                disabled,
              }}
            />
            <div className="flex align-items-center justify-content-center w-6rem bg-gray-200 border-1 border-400">
              歲
            </div>
          </div>
        </div>
        <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 py-0 mb-0">
          <label
            htmlFor="height"
            className={classNames(
              { "p-error": errors.height },
              "col-12 sm:col-3 text-left sm:text-right -mb-1 sm:mb-0"
            )}
          >
            身高
          </label>
          <div className="flex col-12 sm:col-6 pt-0">
            <FormInputnumber
              className="w-full -mr-1px"
              setting={setting}
              data={{
                name: "height",
                disabled,
              }}
            />
            <div className="flex align-items-center justify-content-center w-6rem bg-gray-200 border-1 border-400">
              公分
            </div>
          </div>
        </div>
        <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 py-0 mb-0">
          <label
            htmlFor="is_job"
            className={classNames(
              { "p-error": errors.is_job },
              "col-12 sm:col-3 text-left sm:text-right -mb-1 sm:mb-0"
            )}
          >
            工作
          </label>
          <div className="flex flex-wrap col-12 sm:col-6 pl-1 pt-0">
            <FormRadio
              setting={setting}
              data={{
                name: "is_job",
                label: "是",
                value: 1,
                disabled,
              }}
            />
            <FormRadio
              setting={setting}
              data={{
                name: "is_job",
                label: "否",
                value: 2,
                disabled,
              }}
            />
          </div>
        </div>
        <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 py-0 mb-0">
          <label
            htmlFor="cel"
            className={classNames(
              { "p-error": errors.cel },
              "col-12 sm:col-3 text-left sm:text-right -mb-1 sm:mb-0"
            )}
          >
            手機
          </label>
          <div className="col-12 sm:col-6 pt-0">
            <FormInputtext
              setting={setting}
              data={{
                name: "cel",
                disabled,
              }}
            />
          </div>
        </div>

        <div className="flex flex-column align-items-start sm:flex-row sm:align-items-center field col-12 py-0 mb-0">
          <label
            htmlFor="is_fhofpchd"
            className={classNames(
              { "p-error": errors.is_fhofpchd },
              "col-12 sm:col-3 text-left sm:text-right -mb-1 sm:mb-0"
            )}
          >
            早發冠心病家族史
          </label>
          <div className="flex flex-wrap col-12 sm:col-10 lg:col-5 md:col-8 pl-1 pt-0">
            <FormRadio
              setting={setting}
              data={{
                name: "is_fhofpchd",
                label: "是",
                value: 1,
              }}
            />
            <FormRadio
              setting={setting}
              data={{
                name: "is_fhofpchd",
                label: "否",
                value: 0,
              }}
            />
          </div>
        </div>

        {!disabled && (
          <div className="w-full text-right mt-3 pr-3">
            <Button className="ml-4 px-4" type="submit" label="儲存" />
          </div>
        )}
      </form>
    </>
  );
}
